abc


/*****************
 ** WEBPACK FOOTER
 ** ./loaders/_resources/abc.txt
 ** module id = 2
 ** module chunks = 0
 **/